import PropTypes from 'prop-types'
import { Avatar, Dropdown, Menu, Popover, Tooltip } from 'antd'
import { isNil, map, xor } from 'lodash'
import { nameToColor } from '../../utils/columns'
import './ProfilePictureGroup.less'

const ProfilePictureGroup = ({
  profiles,
  maxImages = 5,
  type = 'summit',
  diameter = 32,
  style,
  showImageOnPopover = true,
}) => {
  // let profiles = props.profiles;
  // let slicedProfiles = props.profiles;
  // let maxImages = props.maxImages;
  // let slicedImages = false;

  const ellipsisClassName = `round-profile-thumbnail-group profile-ellipsis-${type}`
  const slicedImages = profiles.length > parseInt(maxImages)

  if (typeof maxImages === 'undefined') maxImages = 5

  const shownNames = slicedImages ? profiles.slice(0, maxImages) : profiles
  const moreNames = slicedImages ? xor(profiles, shownNames) : []

  let indexCtr = 0
  const avatarList = (
    <Menu>
      {map(moreNames, (x) => (
        <Menu.Item key={x.name}>
          <Popover
            key={x.name}
            overlayClassName={`ProfilePictureGroup-dropdown-popover ProfilePictureGroup-dropdown-popover-${
              (isNil(x.profilePicture) && isNil(x.imageURL)) ||
              !showImageOnPopover
                ? 'no-'
                : '-'
            }image`}
            content={
              (!isNil(x.profilePicture) || !isNil(x.imageURL)) &&
              showImageOnPopover && (
                <div style={{ textAlign: 'center' }}>
                  <img
                    style={{ borderRadius: '50px' }}
                    src={
                      isNil(x.profilePicture)
                        ? x.imageURL
                        : x.profilePicture.imageURL
                    }
                    alt=""
                    width="100px"
                    height="100px"
                  />
                </div>
              )
            }
          >
            <Avatar
              src={
                isNil(x.profilePicture) ? x.imageURL : x.profilePicture.image
              }
              style={{
                backgroundColor: nameToColor(x.firstName, x.lastName),
                fontSize: '14px',
              }}
              shape="circle"
              size={diameter}
              className="dropdown-avatar"
            >
              {x.firstName[0] + x.lastName[0]}
            </Avatar>
          </Popover>
          {x.name}
        </Menu.Item>
      ))}
    </Menu>
  )
  return (
    <div className="round-profile-imagegroup" style={style}>
      {shownNames.map((x) => (
        <Popover
          title={x.name}
          key={x.name}
          overlayClassName={`ProfilePictureGroup-popover ProfilePictureGroup-popover-${
            (isNil(x.profilePicture) && isNil(x.imageURL)) ||
            !showImageOnPopover
              ? 'no-'
              : '-'
          }image`}
          content={
            (!isNil(x.profilePicture) || !isNil(x.imageURL)) &&
            showImageOnPopover && (
              <div style={{ textAlign: 'center' }}>
                <img
                  style={{ borderRadius: '50px' }}
                  src={
                    isNil(x.profilePicture)
                      ? x.imageURL
                      : x.profilePicture.image
                  }
                  alt=""
                  width="100px"
                  height="100px"
                />
              </div>
            )
          }
        >
          <Avatar
            src={isNil(x.profilePicture) ? x.imageURL : x.profilePicture.image}
            style={{
              position: 'relative',
              zIndex: 150 + indexCtr++,
              display: 'inline-block',
              backgroundColor: nameToColor(x.firstName, x.lastName),
              fontSize: '14px',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            shape="circle"
            size={diameter}
            className="round-profile-thumbnail-group"
          >
            {x.firstName[0] + x.lastName[0]}
          </Avatar>
        </Popover>
      ))}
      {slicedImages && (
        <Dropdown overlay={avatarList}>
          <Avatar
            style={{
              position: 'relative',
              zIndex: 150 + indexCtr++,
              display: 'inline-block',
              fontSize: '14px',
              textAlign: 'center',
              verticalAlign: 'middle',
            }}
            shape="circle"
            size={diameter}
            className={ellipsisClassName}
          >
            +{profiles.length - parseInt(maxImages)}
          </Avatar>
        </Dropdown>
      )}
    </div>
  )
}

ProfilePictureGroup.propTypes = {
  profiles: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
    })
  ).isRequired,
  maxImages: PropTypes.number,
  type: PropTypes.string,
  diameter: PropTypes.number,
  style: PropTypes.object,
  showImageOnPopover: PropTypes.bool,
}

export default ProfilePictureGroup
